import { getFontAwesomeIcon, getMaximizerIcon, getSvgIcon } from './icon-name';
import { Octopus } from '@maximizer/core/shared/domain';
export const InteractionIcons: { [value: number | string]: string } = {
  18: getFontAwesomeIcon('mug-saucer', 'solid'),
  34: getFontAwesomeIcon('envelope'),
  42: getFontAwesomeIcon('tags', 'solid'),
  59: getFontAwesomeIcon('video', 'solid'),
  122: getFontAwesomeIcon('square-twitter', 'brand'),
  123: getFontAwesomeIcon('square-facebook', 'brand'),
  133: getFontAwesomeIcon('linkedin', 'brand'),
  150: getFontAwesomeIcon('rss', 'solid'),
  219: getFontAwesomeIcon('utensils', 'solid'),
  237: getFontAwesomeIcon('desktop', 'solid'),
  245: getFontAwesomeIcon('circle', 'solid'),
  321: getFontAwesomeIcon('thumbs-up', 'solid'),
  430: getFontAwesomeIcon('paper-plane', 'solid'),
  437: getFontAwesomeIcon('share-nodes', 'solid'),
  512: getFontAwesomeIcon('whatsapp', 'brand'),
  534: getFontAwesomeIcon('note-sticky', 'solid'),
  602: getFontAwesomeIcon('hashtag', 'solid'),
  635: getFontAwesomeIcon('handshake'),
  643: getFontAwesomeIcon('circle-user', 'solid'),
  646: getFontAwesomeIcon('id-badge'),
  677: getSvgIcon('docusign'),
  678: getSvgIcon('zendesk'),
  679: getSvgIcon('sendgrid'),
  680: getSvgIcon('surveymonkey'),
  681: getSvgIcon('whatsapp-logo'),
  683: getSvgIcon('zoom-logo'),
  684: getSvgIcon('msteams-logo'),
  685: getSvgIcon('readai-logo'),
  686: getSvgIcon('fireflies-logo'),
  [Octopus.DefaultInteractions.CALL]: getFontAwesomeIcon('phone', 'solid'),
  [Octopus.DefaultInteractions.EMAIL]: getFontAwesomeIcon('envelope', 'solid'),
  [Octopus.DefaultInteractions.APPOINTMENT]: getFontAwesomeIcon('calendar'),
  [Octopus.DefaultInteractions.TASK]: getFontAwesomeIcon(
    'circle-check',
    'solid',
  ),
  [Octopus.DefaultInteractions.SMS]: getFontAwesomeIcon('comments', 'solid'),
  [Octopus.DefaultInteractions.CHAT]: getFontAwesomeIcon(
    'comment-dots',
    'solid',
  ),
  [Octopus.DefaultInteractions.NOTE]: getFontAwesomeIcon(
    'note-sticky',
    'solid',
  ),
  [Octopus.DefaultInteractions.DOCUMENT]: getMaximizerIcon('document-uploaded'),
  [Octopus.RecurringInteractions.Task]: getMaximizerIcon('recurring-task'),
  [Octopus.RecurringInteractions.Appointment]: getMaximizerIcon(
    'recurring-appointment',
  ),
  [Octopus.WorkflowInteractions.Task]: getFontAwesomeIcon(
    'arrow-progress',
    'solid',
  ),
};

export const InteractionTaskIcons: { [value: number | string]: string } = {
  1: getFontAwesomeIcon('envelope'),
  2: getFontAwesomeIcon('calendar-check'),
  3: getFontAwesomeIcon('phone'),
  4: getFontAwesomeIcon('paper-plane'),
  5: getFontAwesomeIcon('money-bill'),
  6: getFontAwesomeIcon('utensils'),
  7: getFontAwesomeIcon('chart-line'),
  8: getFontAwesomeIcon('comment-dots'),
  9: getFontAwesomeIcon('thumbs-up'),
};
